export default "__VITE_ASSET__524237d3__"